import React from "react"
import { useTaskReportExportContext } from "contexts/TaskReportExportContext"
import * as API from "services/api"
import { SmallWrap } from "shared/wraps"
import { DataCollectorContainer, DataCollectorStep } from "shared/dataCollector"
import { errorToast } from "shared/toast"
import NewTaskReportExportClosedDateFilters from "./NewTaskReportExportClosedDateFilters"
import NewTaskReportExportDueDateFilters from "./NewTaskReportExportDueDateFilters"
import NewTaskReportExportFileTypeSelect from "./NewTaskReportExportFileTypeSelect"
import NewTaskReportExportFormActions from "./NewTaskReportExportFormActions"
import NewTaskReportExportSubmittableFormFilter from "./NewTaskReportExportSubmittableFormFilter"
import NewTaskReportExportTaskStatuses from "./NewTaskReportExportTaskStatuses"

const CREATE_REPORT_EXPORT_ERROR_MESSAGE = "Something went wrong.  Unable to initiate export."

const NewTaskReportExportForm = () => {
  const {
    earliestClosedDate,
    earliestDueDate,
    includeClosedTasks,
    includedFormSlugs,
    includeOpenTasks,
    latestClosedDate,
    latestDueDate,
    noSubmittableFormIncluded,
    noTaskStatusIncluded,
    reportExportFileType,
    setReportExport,
    taskReport,
  } = useTaskReportExportContext()

  const { id: taskReportId, name: taskReportName } = taskReport

  const renderDataCollectorHeaderContent = () => (
    <span className="font-medium text-xl">{taskReportName}</span>
  )

  const exportTaskReport = async () => {
    const response = await API.createTaskReportExport({
      earliestClosedDate,
      earliestDueDate,
      includeClosedTasks,
      includedFormSlugs,
      includeOpenTasks,
      latestClosedDate,
      latestDueDate,
      reportFileType: reportExportFileType,
      reportId: taskReportId,
    })

    if (response.ok) {
      setReportExport(response.data)
    } else {
      errorToast(CREATE_REPORT_EXPORT_ERROR_MESSAGE)
    }
  }

  return (
    <SmallWrap>
      <DataCollectorContainer renderHeaderContent={renderDataCollectorHeaderContent}>
        <div className="mb-6">
          <DataCollectorStep stepNumber={1} heading="Select the Task Statuses to Include">
            <NewTaskReportExportTaskStatuses />
          </DataCollectorStep>
          <DataCollectorStep stepNumber={2} heading="Filter by the Date the Task is Due">
            <NewTaskReportExportDueDateFilters />
          </DataCollectorStep>
          {
            // Only meaningful when closed tasks are being exported, so it is not offered otherwise.
            includeClosedTasks && (
              <DataCollectorStep stepNumber={3} heading="Filter by the Date the Task was Closed">
                <NewTaskReportExportClosedDateFilters />
              </DataCollectorStep>
            )
          }
          <DataCollectorStep stepNumber={includeClosedTasks ? 4 : 3} heading="Filter by the Submitted Form">
            <NewTaskReportExportSubmittableFormFilter />
          </DataCollectorStep>
          <DataCollectorStep stepNumber={includeClosedTasks ? 5 : 4} heading="Select File Type">
            <NewTaskReportExportFileTypeSelect />
          </DataCollectorStep>
        </div>
        <NewTaskReportExportFormActions
          disabled={noTaskStatusIncluded || noSubmittableFormIncluded}
          exportTaskReport={exportTaskReport}
        />
      </DataCollectorContainer>
    </SmallWrap>
  )
}

export default NewTaskReportExportForm
